import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, Globe, MapPin } from 'lucide-react';

const Footer = () => {
  const handleLinkClick = () => window.scrollTo({ top: 0, behavior: 'smooth' });
  const year = new Date().getFullYear();

  return (
    <footer className="relative bg-[#008080] text-white overflow-hidden" data-testid="site-footer">
      <div className="absolute inset-0 bp-grid-on-dark opacity-30 pointer-events-none"></div>
      <div className="spotlight-gold -top-16 right-0"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-10">
        <div className="border-b border-white/15 pb-12 mb-12">
          <div className="flex items-start justify-between gap-6 flex-wrap">
            <div>
              <span className="ark-overline-light">// ARK · MH-PUNE-2026</span>
              <h2 className="font-display font-black uppercase tracking-tighter text-white text-5xl sm:text-7xl lg:text-8xl mt-3 leading-[0.85]">
                ARK<br />
                <span className="text-[#DAA520]">Scaffolding</span>
              </h2>
              <p className="mt-6 max-w-md text-white/85 leading-relaxed">
                Heavy-duty scaffolding material on hire. Inspected, certified and dispatched fast across Pune, PCMC and Maharashtra.
              </p>
            </div>
            <div className="flex gap-3">
              <a href="tel:+919766601155" className="ark-btn-primary" data-testid="footer-call-btn">
                <Phone size={16} /> Call Now
              </a>
              <a href="https://wa.me/919766601155" target="_blank" rel="noopener noreferrer" className="ark-btn-secondary ark-btn-secondary-dark" data-testid="footer-whatsapp-btn">
                WhatsApp
              </a>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-10 mb-12">
          <div>
            <h3 className="font-mono text-xs uppercase tracking-[0.25em] text-[#DAA520] mb-5">// Navigate</h3>
            <ul className="space-y-3">
              {[
                { name: 'Home', path: '/' },
                { name: 'About Us', path: '/about' },
                { name: 'Products', path: '/products' },
                { name: 'Gallery', path: '/gallery' },
                { name: 'Cuplock System', path: '/cuplock' },
                { name: 'Contact', path: '/contact' },
                { name: 'Download Brochure', path: '/brochure' },
              ].map((l) => (
                <li key={l.path}>
                  <Link to={l.path} onClick={handleLinkClick} className="text-white/85 hover:text-[#DAA520] transition-colors text-sm flex items-center gap-2 group">
                    <span className="w-3 h-px bg-white/40 group-hover:bg-[#DAA520] group-hover:w-5 transition-all"></span>
                    {l.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-mono text-xs uppercase tracking-[0.25em] text-[#DAA520] mb-5">// Contact</h3>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3 text-white/85">
                <MapPin className="w-4 h-4 text-[#DAA520] mt-0.5 flex-shrink-0" />
                <span>Survey No. 148/5, Opp. Sandeep Kate Bunglow,<br />Pimple Saudagar, Pune - 411027</span>
              </li>
              <li className="flex items-center gap-3 text-white/85">
                <Phone className="w-4 h-4 text-[#DAA520] flex-shrink-0" />
                <a href="tel:+919766601155" className="hover:text-white transition-colors">+91 9766601155</a>
              </li>
              <li className="flex items-center gap-3 text-white/85">
                <Mail className="w-4 h-4 text-[#DAA520] flex-shrink-0" />
                <a href="mailto:info@arkscaffolding.in" className="hover:text-white transition-colors">info@arkscaffolding.in</a>
              </li>
              <li className="flex items-center gap-3 text-white/85">
                <Globe className="w-4 h-4 text-[#DAA520] flex-shrink-0" />
                <a href="https://www.arkscaffolding.in" className="hover:text-white transition-colors">www.arkscaffolding.in</a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-mono text-xs uppercase tracking-[0.25em] text-[#DAA520] mb-5">// Service Areas</h3>
            <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-sm text-white/85">
              {['Pune', 'PCMC', 'Mumbai', 'Thane', 'Nashik', 'Solapur', 'Kolhapur', 'Aurangabad', 'Wakad', 'Hinjewadi', 'Baner', 'Chinchwad', 'Nigdi', 'Ravet'].map((c) => (
                <span key={c} className="flex items-center gap-1.5">
                  <span className="w-1 h-1 bg-[#DAA520]"></span> {c}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-white/15 pt-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/70 font-mono">
          <span>© {year} ARK SCAFFOLDING · ALL RIGHTS RESERVED</span>
          <span className="flex items-center gap-4">
            <span className="flex items-center gap-2"><span className="w-1.5 h-1.5 bg-[#10B981] rounded-full radar-dot"></span>SYSTEM · LIVE</span>
            <span>BUILD · 2026.02</span>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
